import { useState } from 'react';
import { type MyAccountTab, useMyAccountStore } from '../../../stores/useMyAccountStore';

interface MyAccountNavProps {
  isUsingSSO: boolean;
}

export function MyAccountNav({ isUsingSSO }: MyAccountNavProps) {
  const { activeTab, setActiveTab } = useMyAccountStore();
  const [showNav, setShowNav] = useState(true);

  function handleTabClick(e: React.MouseEvent, tab: MyAccountTab) {
    e.preventDefault();
    setActiveTab(tab);
  }

  return (
    <>
      <div className="account-nav desktop">
        <ul>
          {!isUsingSSO && (
            <li>
              <h3>Account Services</h3>
              <ul className="inner-ul">
                <li className={activeTab === 'security' ? 'active' : ''}>
                  {/** biome-ignore lint/a11y/useValidAnchor: using anchor for tab navigation */}
                  <a href="#" onClick={e => handleTabClick(e, 'security')}>
                    Security Info
                  </a>
                </li>
              </ul>
            </li>
          )}
          <li>
            <h3>Communications</h3>
            <ul className="inner-ul">
              <li className={activeTab === 'notifications' ? 'active' : ''}>
                {/** biome-ignore lint/a11y/useValidAnchor: using anchor for tab navigation */}
                <a href="#" onClick={e => handleTabClick(e, 'notifications')}>
                  Manage Notifications
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      {/* Mobile equivalent — CSS (max-width: 600px) hides .desktop and shows .mobile.
          The menu list intentionally does not use the legacy `.mobile-menu` class:
          that class is `position: absolute` in style.css, which was designed around the
          legacy float-based `.account-nav-wrapper` layout and overlaps the Bootstrap
          `.col-md-8` content column used here. Flowing it normally avoids that overlap. */}
      <div className="account-nav mobile">
        <div className="mobile-nav-container">
          <button
            type="button"
            className="glyphicon glyphicon-align-justify"
            aria-label="Toggle account menu"
            aria-expanded={showNav}
            onClick={() => setShowNav(prev => !prev)}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              color: 'inherit',
              fontSize: 'inherit',
              cursor: 'pointer',
            }}
          />
        </div>
        {showNav && (
          <ul style={{ listStyleType: 'none', margin: 0, padding: 0, background: '#fff' }}>
            {!isUsingSSO && (
              <li>
                <h3>Account Services</h3>
                <ul className="inner-ul">
                  <li className={activeTab === 'security' ? 'active' : ''}>
                    {/** biome-ignore lint/a11y/useValidAnchor: using anchor for tab navigation */}
                    <a
                      href="#"
                      onClick={e => {
                        handleTabClick(e, 'security');
                        setShowNav(false);
                      }}
                    >
                      Security Info
                    </a>
                  </li>
                </ul>
              </li>
            )}
            <li>
              <h3>Communications</h3>
              <ul className="inner-ul">
                <li className={activeTab === 'notifications' ? 'active' : ''}>
                  {/** biome-ignore lint/a11y/useValidAnchor: using anchor for tab navigation */}
                  <a
                    href="#"
                    onClick={e => {
                      handleTabClick(e, 'notifications');
                      setShowNav(false);
                    }}
                  >
                    Manage Notifications
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        )}
      </div>
    </>
  );
}
